import { MENU_IDS, TRAIL_REACTIVATION_URL } from './constants';

export const REACT_APP_MOBILE_BANNER_URL = 'https://mobile.fabfitfun.com';

const getDynamicLinks = (env) => ({
  REACT_APP_MOBILE_BANNER: `${env.REACT_APP_MOBILE_DYNAMIC_LINK_BASE_URL}${
    env.name === 'prod' ? '/install-the-app' : '/install'
  }`,
  REACT_APP_MOBILE_BANNER_MY_ACCOUNT: `${env.REACT_APP_MOBILE_DYNAMIC_LINK_BASE_URL}/my_account`,
  REACT_APP_MOBILE_BANNER_ORDERS: `${env.REACT_APP_MOBILE_DYNAMIC_LINK_BASE_URL}/Orders`,
  REACT_APP_MOBILE_BANNER_INVOICE: `${env.REACT_APP_MOBILE_DYNAMIC_LINK_BASE_URL}/invoice`,
  REACT_APP_MOBILE_BANNER_BOX: `${env.REACT_APP_MOBILE_DYNAMIC_LINK_BASE_URL}/box`,
  REACT_APP_MOBILE_BANNER_TALK: `${env.REACT_APP_MOBILE_DYNAMIC_LINK_BASE_URL}/talk`,
  REACT_APP_MOBILE_BANNER_SHOP: `${env.REACT_APP_MOBILE_DYNAMIC_LINK_BASE_URL}/shop`,
  REACT_APP_MOBILE_BANNER_EDIT: `${env.REACT_APP_MOBILE_DYNAMIC_LINK_BASE_URL}/edit`,
  REACT_APP_MOBILE_BANNER_ADD_ONS: `${env.REACT_APP_MOBILE_DYNAMIC_LINK_BASE_URL}/add-ons`,
  REACT_APP_MOBILE_BANNER_RATE_AND_REVIEW: `${env.REACT_APP_MOBILE_DYNAMIC_LINK_BASE_URL}/rate_and_review`,
  REACT_APP_MOBILE_BANNER_INVITE_A_FRIEND: `${env.REACT_APP_MOBILE_DYNAMIC_LINK_BASE_URL}/InviteFriends`,
});

const getValidUserAgent = () => {
  if (typeof navigator === 'undefined' || !navigator.userAgent) {
    return '';
  }
  return navigator.userAgent;
};

const buildUniversalLink = (env, pathname) => {
  const iosRegex = new RegExp(/iP(hone|od|ad)/);
  const androidRegex = new RegExp(/Android/);
  let baseUrl = `${REACT_APP_MOBILE_BANNER_URL}?to=${env.REACT_APP_BASE_URL}`;
  if (pathname) {
    baseUrl = `${baseUrl}/${pathname}`;
  }

  switch (true) {
    case iosRegex.test(getValidUserAgent()):
      return `${baseUrl}&platform=ios`;
    case androidRegex.test(getValidUserAgent()):
      return `${baseUrl}&platform=android`;
    default:
      return baseUrl;
  }
};

const getUniversalLinks = (env) => ({
  REACT_APP_MOBILE_BANNER: buildUniversalLink(env, ''),
  REACT_APP_MOBILE_BANNER_ORDERS: buildUniversalLink(env, 'my-account/orders'),
  REACT_APP_MOBILE_BANNER_INVITE_A_FRIEND: buildUniversalLink(env, 'invite-friends'),
  REACT_APP_MOBILE_BANNER_MY_ACCOUNT: buildUniversalLink(env, 'my-account'),
  REACT_APP_MOBILE_BANNER_INVOICE: buildUniversalLink(env, 'my-account/invoice-history'),
  REACT_APP_MOBILE_BANNER_TALK: buildUniversalLink(env, 'talk'),
  REACT_APP_MOBILE_BANNER_SHOP: buildUniversalLink(env, 'shop'),
  REACT_APP_MOBILE_BANNER_EDIT: buildUniversalLink(env, 'edit'),
  REACT_APP_MOBILE_BANNER_ADD_ONS: buildUniversalLink(env, 'add-ons'),
  REACT_APP_MOBILE_BANNER_RATE_AND_REVIEW: buildUniversalLink(env, 'my-account/rate-and-review'),
  REACT_APP_MOBILE_BANNER_BOX: buildUniversalLink(env, 'my-box'),
});

export const getAppMobileLink = (env, mobileAppWebBannerUniversalLinks) => {
  const dynamicLinks = getDynamicLinks(env);
  const universalLinks = getUniversalLinks(env);
  const { pathname } = window.location;
  switch (true) {
    case pathname.replace(/\/$/, '').endsWith('my-account'):
      return mobileAppWebBannerUniversalLinks
        ? universalLinks.REACT_APP_MOBILE_BANNER_MY_ACCOUNT
        : dynamicLinks.REACT_APP_MOBILE_BANNER_MY_ACCOUNT;
    case pathname.endsWith('/orders'):
      return mobileAppWebBannerUniversalLinks
        ? universalLinks.REACT_APP_MOBILE_BANNER_ORDERS
        : dynamicLinks.REACT_APP_MOBILE_BANNER_ORDERS;
    case pathname.endsWith('/invoice-history'):
      return mobileAppWebBannerUniversalLinks
        ? universalLinks.REACT_APP_MOBILE_BANNER_INVOICE
        : dynamicLinks.REACT_APP_MOBILE_BANNER_INVOICE;
    case pathname.endsWith('/my-box') || pathname.endsWith('/my-subscriptions'):
      return mobileAppWebBannerUniversalLinks
        ? universalLinks.REACT_APP_MOBILE_BANNER_BOX
        : dynamicLinks.REACT_APP_MOBILE_BANNER_BOX;
    case pathname.endsWith('/invite-friends'):
      return mobileAppWebBannerUniversalLinks
        ? universalLinks.REACT_APP_MOBILE_BANNER_INVITE_A_FRIEND
        : dynamicLinks.REACT_APP_MOBILE_BANNER_INVITE_A_FRIEND;
    case pathname.includes('talk'):
      return mobileAppWebBannerUniversalLinks
        ? universalLinks.REACT_APP_MOBILE_BANNER_TALK
        : dynamicLinks.REACT_APP_MOBILE_BANNER_TALK;
    case pathname.includes('shop'):
      return mobileAppWebBannerUniversalLinks
        ? universalLinks.REACT_APP_MOBILE_BANNER_SHOP
        : dynamicLinks.REACT_APP_MOBILE_BANNER_SHOP;
    case pathname.includes('edit'):
      return mobileAppWebBannerUniversalLinks
        ? universalLinks.REACT_APP_MOBILE_BANNER_EDIT
        : dynamicLinks.REACT_APP_MOBILE_BANNER_EDIT;
    case pathname.includes('add-ons'):
      return mobileAppWebBannerUniversalLinks
        ? universalLinks.REACT_APP_MOBILE_BANNER_ADD_ONS
        : dynamicLinks.REACT_APP_MOBILE_BANNER_ADD_ONS;
    case pathname.endsWith('rate-and-review'):
      return mobileAppWebBannerUniversalLinks
        ? universalLinks.REACT_APP_MOBILE_BANNER_RATE_AND_REVIEW
        : dynamicLinks.REACT_APP_MOBILE_BANNER_RATE_AND_REVIEW;
    default:
      return mobileAppWebBannerUniversalLinks
        ? universalLinks.REACT_APP_MOBILE_BANNER
        : dynamicLinks.REACT_APP_MOBILE_BANNER;
  }
};

export const updateRouteForTrial = (loggedRoutes = []) => {
  return loggedRoutes.map((loggedRoute) => ({
    ...loggedRoute,
    subRoutes:
      loggedRoute.id === MENU_IDS.MY_BOX
        ? loggedRoute.subRoutes.map((subroute) => ({
            ...subroute,
            route: subroute.id === MENU_IDS.CUSTOMIZE ? TRAIL_REACTIVATION_URL : subroute.route,
          }))
        : loggedRoute.subRoutes,
  }));
};
